'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getDisplayName = require('recompose/getDisplayName');

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _wrapDisplayName = require('recompose/wrapDisplayName');

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _reactContextProps = require('react-context-props');

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Target) {
  var name = (0, _getDisplayName2.default)(Target);

  var WithOverrideFromContext = (0, _reactContextProps.withPropsFromContext)([name])(function (props) {
    var Override = props[name];

    var propsWithoutOverride = _extends({}, props);
    delete propsWithoutOverride[name];

    if (typeof Override === 'function') {
      return _react2.default.createElement(Override, propsWithoutOverride);
    } else if (Override != null) {
      return _react2.default.createElement(Target, (0, _deepmerge2.default)(propsWithoutOverride, Override));
    } else {
      return _react2.default.createElement(Target, propsWithoutOverride);
    }
  });

  WithOverrideFromContext.displayName = (0, _wrapDisplayName2.default)(Target, 'withOverrideFromContext');

  return WithOverrideFromContext;
};